import React from "react";
import { inject, observer } from "mobx-react";
import { observable, computed } from "mobx";
import { RouteComponentProps } from "react-router";
import { Formik, FormikProps } from "formik";
import {
    FormWithCenteredContent,
    AuthProvidersGridRoot,
    AuthProvidersGridTitle,
    AuthProviderName,
    AuthProviderImg,
    AuthProvidersGridContent,
    AuthProvidersGrid,
} from "./styles";
import { IAuthStore } from "Stores/Auth/types";
import { IValuesStore } from "Stores/Values/types";
import { Values } from "Tools/Values";
import { IManagementStore } from "@src/Stores/Management/types";
import { RouterStore } from "mobx-react-router";
import { STSelectLocation } from "../SelectLocation/styles";
import { ShortAuthProvider } from "@src/Interfaces/Entity/OAuthProvider";
import { oauthLogInRoute, oauthLogInErrorRoute } from "@src/Stores/Auth/types";
import qs from "query-string";
import { IAuthByProviderRequestOptions } from "../../../../Interfaces/AuthRequest";

interface IProps extends RouteComponentProps {
    auth?: IAuthStore;
    values?: IValuesStore;
    management?: IManagementStore;
    routing?: RouterStore;
    forceUpdate?: any;
}
export interface IFormFields {
    location: string;
}

interface IOutputParams {
    ssopostback?: string;
    mode?: string;
}

@inject("auth", "values", "routing", "management")
@observer
class LoginWithRequiredProvider extends React.Component<IProps> {
    @observable lastLocation: string = "";
    @observable requiredProvider: ShortAuthProvider = null;

    constructor(props: IProps) {
        super(props);
        const lastLocation: string = localStorage.getItem("lastLocation");
        if (lastLocation) {
            this.lastLocation = lastLocation;
        }

        this.requiredProvider = this.props.management.shortRequiredAuthProviders;
    }

    @computed get location() {
        let location = this.props.values.location ? this.props.values.location : this.lastLocation;
        if (!location && this.props.values.loginLocations.length === 1) {
            return this.props.values.loginLocations[0].id;
        }
    }

    @computed get hasAnyOAuthProviders() {
        return this.props.management.shortAuthProviders.length > 0;
    }

    handleLoginViaExternalProvider = async (provider: ShortAuthProvider, locationId: string) => {
        try {
            const queryString: IOutputParams = (qs.parse(this.props.location.search) as unknown) as IOutputParams;

            const queryLowerCased: IOutputParams = {};

            Object.entries(queryString).forEach(([key, value]) => {
                return (queryLowerCased[key.toLowerCase()] = value);
            });

            const tenantParam = new URLSearchParams(this.props.location.search).get("tenant");

            if ((this.props.location.pathname.match(oauthLogInRoute)
                || this.props.location.pathname.match(oauthLogInErrorRoute))
                && this.props.location.search.match("response_type=code")) {
                let options: IAuthByProviderRequestOptions = {
                    oAuthProviderId: provider.id,
                    locationId: locationId,
                    ssoPostBack: queryLowerCased.ssopostback || "",
                    ssoPostBackMode: queryLowerCased.mode || "",
                    ssoPostBackHash: this.props.location.hash.replace("#","") || "",
                    associatedPersonId: null
                }

                await this.props.auth.signInViaOAuth2ByProvider(this.props.location.search, options);
            } else {
                await this.props.auth.signInViaExternalProvider(
                    provider.id,
                    locationId,
                    queryLowerCased.ssopostback || "",
                    queryLowerCased.mode || "",
                    this.props.location.hash || "",
                    tenantParam
                );
            }
        } catch (error) {
            console.error(error);
        }
    };

    render() {
        const currentLocation = this.props.values.loginLocations.find(
            (location) => location.id === this.props.values.location
        );
        const defaultProviderImageurl = "/images/icon-oauth-default.png";
        /*TODO - remove formik according to task ZWP-145*/
        return (
            <>
                <Formik
                    onSubmit={ null }
                    initialValues={{
                        location: this.location,
                    }}
                    render={(formikProps: FormikProps<IFormFields>) => (
                        <FormWithCenteredContent onSubmit={formikProps.handleSubmit} data-test-id={"login-form"}>
                            {!this.props.values.location && (
                                <STSelectLocation value={formikProps.values.location} formikProps={formikProps} />
                            )}
                            {((this.props.values.location && currentLocation && currentLocation.primary) ||
                                !this.props.values.location) && (
                                    <AuthProvidersGridRoot>
                                        <AuthProvidersGridTitle>{Values.getLocalizationValue("signInWith")}</AuthProvidersGridTitle>
                                        <AuthProvidersGrid container>
                                        {
                                            <AuthProvidersGridContent
                                                key={this.requiredProvider.id}
                                                onClick={() => this.handleLoginViaExternalProvider(this.requiredProvider, formikProps.values.location)}
                                            >
                                                <AuthProviderImg src={this.requiredProvider.iconUrl} onError={(e: any) => (e.target.onerror = null, e.target.src = defaultProviderImageurl)} />
                                                <AuthProviderName>{this.requiredProvider.displayTitle}</AuthProviderName>
                                            </AuthProvidersGridContent>
                                        }
                                        </AuthProvidersGrid>
                                    </AuthProvidersGridRoot>
                                )}
                        </FormWithCenteredContent>
                    )}
                />
            </>
        );
    }
}

export default LoginWithRequiredProvider;
